module.exports = __webpack_public_path__ + "img/_IKA4101.17f22bd0.jpg";